import styled from '@mui/material/styles/styled';

export const Content = styled('div')(() => ({
  minHeight: 240,
  display: 'flex',
  flexDirection: 'column',
  padding: '0 40px 32px',
}));

export const Actions = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  gap: '8px',
  marginTop: 'auto',
}));